import type { TFunction } from "i18next";

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

/**
 * Default custom invoice email body (HTML) — mirrors the standard template copy
 * (heading + intro). Stored as HTML; the WYSIWYG editor loads and emits HTML.
 */
export function getDefaultInvoiceEmailCustomHtml(t: TFunction): string {
  const heading = escapeHtml(t("clients.form.invoiceEmailDefaultHeading"));
  const intro = escapeHtml(t("clients.form.invoiceEmailDefaultIntro"));
  return `<h1>${heading}</h1><p>${intro}</p>`;
}
